import { Component, OnChanges, OnInit, AfterViewInit, AfterViewChecked, ElementRef } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { CancelParticipationService } from './shared/providers/cancel-participation.service';
import { Router } from '@angular/router';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { BREADCRUMBS, MOBILEPIVOTS } from 'config';

@Component({
  selector: 'app-cancel-participation',
  templateUrl: './cancel-participation.component.html',
  styleUrls: ['./cancel-participation.component.scss'],
  providers: [CancelParticipationService]
})

export class CancelParticipationComponent implements OnInit {
  sessionName: string;
  pivots: Array<MobilePivotModel>;
  constructor(
  private cancelParticipationService: CancelParticipationService,
  private breadCrumbService: BreadCrumbService) {
  }

  ngOnInit() {
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Remove accounts', routerLink: '/cancelParticipation' });
    this.sessionName = 'Remove Accounts';
    this.pivots = MOBILEPIVOTS.CANCELPARTICIPATION;
  }
}
